// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"70b07c4d","210":"faf9ec4e","940":"08ebb6a6"}[chunkId] + ".chunk.css";
};